import { NgFor, AsyncPipe, DatePipe } from '@angular/common';
import { Component } from '@angular/core';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MatNavList,
  MatListItem,
  MatListItemAvatar,
  MatListItemTitle,
  MatListItemLine,
  MatListItemMeta,
} from '@angular/material/list';
import { Router, RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { PageToolbarComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { AnimalGroup } from '../../models/animal-group.model';
import * as animalGroupActions from '../../store/animal-group.actions';
import { getAnimalGroups } from '../../store/animal-group.selectors';

@Component({
  selector: 'app-animal-group-overview',
  templateUrl: './animal-group-overview.component.html',
  styleUrls: ['./animal-group-overview.component.scss'],
  imports: [
    PageToolbarComponent,
    MatNavList,
    NgFor,
    MatListItem,
    RouterLink,
    MatIcon,
    MatListItemAvatar,
    MatListItemTitle,
    MatListItemLine,
    MatListItemMeta,
    MatIconButton,
    AsyncPipe,
    DatePipe,
    TranslatePipe,
  ],
})
export class AnimalGroupOverviewComponent {
  animalGroups$: Observable<AnimalGroup[]> = this.store
    .select(getAnimalGroups)
    .pipe(map((animalGroups) => animalGroups.sort((a, b) => (a.id < b.id ? 1 : -1))));

  isAnimalGroupsEmpty$: Observable<boolean> = this.animalGroups$.pipe(
    map((animalGroups) => animalGroups.length === 0),
  );

  constructor(
    private readonly store: Store<RootState>,
    private readonly router: Router,
  ) {}

  addAnimalGroup() {
    this.router.navigate(['/animal-group', 'add']);
  }

  delete(event: Event, animalGroup: AnimalGroup) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (animalGroup?.id) {
      this.animalGroups$.pipe(take(1)).subscribe((_) => {
        this.store.dispatch(animalGroupActions.deleteAnimalGroupWithConfirmation({ animalGroup }));
      });
    }
  }
}
